import React from 'react';
import Colors from './Colors.js';
import { navigateTo, updatePageColors } from './helpers/Helpers.js';
import computer from './Computer-Shell.svg';
import { gsap } from 'gsap';
import './Landing.css';

const COMPUTER_WIDTH = 300;
var computerAnimation;

class Landing extends React.Component {
  constructor(props) {
    super(props);
    this.setView = props.setView;
    this.selectComputer = this.selectComputer.bind(this);
    this.state = { transitioning: false };
    this.noiseFrames = [];
    this.canvasContext = null;
    this.noiseInterval = null;
  }

  componentDidMount() {
    // Ensure colors are set after component mounts (backup to route-based update)
    updatePageColors('/');
    
    // Pre-generate noise frames on mount
    const canvas = document.getElementById("tv");
    this.canvasContext = canvas.getContext("2d");
    for (let i = 0; i < 10; i++) {
      const imgd = this.canvasContext.createImageData(64, 64);
      const pix = imgd.data;
      for (let j = 0; j < pix.length; j += 4) {
        const gray = Math.random() * 255 | 0;
        pix[j] = gray;
        pix[j+1] = gray;
        pix[j+2] = gray;
        pix[j+3] = 255;
      }
      this.noiseFrames.push(imgd);
    }
    
    // Force GPU layer creation upfront
    gsap.set("#computer", { 
      force3D: true,
      transformOrigin: "150px 127px"
    });
    
    computerAnimation = gsap.to("#computer", {
      y: "-30",
      duration: 3,
      ease: "circ.inout",
      repeat: -1,
      yoyo: true,
      force3D: true
    });

    gsap.to(".Computer-Shadow", {
      width: COMPUTER_WIDTH - 80,
      duration: 3,
      ease: "circ.inout",
      repeat: -1,
      yoyo: true
    });
  }

  selectComputer() {
    if (this.state.transitioning) return;
    
    computerAnimation.pause();
    this.setState({ transitioning: true });
    
    // Start animated static
    let frame = 0;
    const context = this.canvasContext;
    const noiseFrames = this.noiseFrames;
    
    this.noiseInterval = setInterval(() => {
      context.putImageData(noiseFrames[frame], 0, 0);
      frame = (frame + 1) % noiseFrames.length;
    }, 80);
    
    // Timeline for the animation sequence
    const tl = gsap.timeline({
      onComplete: () => {
        clearInterval(this.noiseInterval);
        navigateTo("/about?from=landing");
      }
    });

    // Hide shadow immediately
    tl.to(".Computer-Shadow", { autoAlpha: 0, duration: 0.01 }, 0);
    
    // At 1s: fade greeting and start zoom
    tl.to("#greeting", { autoAlpha: 0, duration: 0.25 }, 1);
    tl.call(() => {
      document.getElementById("computer").classList.add("zooming");
    }, null, 1);
    
    // Fade to black earlier and longer - hides stuttering static and border flash
    tl.to(".Landing-Overlay", { autoAlpha: 1, duration: 1 }, 1.5);
    
    // Small delay after fully black before navigating
    tl.call(() => {}, null, 2.6);
  }

  render() {
    const { transitioning } = this.state;
    return (
      <div className="Landing-Wrapper">
        <div className="Landing-Overlay"></div>
        <p id="greeting">Hi I'm Ben!</p>
        <div className="Computer-Wrapper">
          <div id="computer" onClick={this.selectComputer}>
            <canvas 
              className="Screen" 
              id="tv" 
              width="64" 
              height="64" 
              style={{
                display: transitioning ? 'block' : 'none'
              }}
            />
            <div 
              className="Screen Screen-Bars" 
              style={{
                display: transitioning ? 'none' : 'flex'
              }}
            >
              <div className="Screen-Bar" style={{"backgroundColor": Colors.red}}></div>
              <div className="Screen-Bar" style={{"backgroundColor": Colors.orange}}></div>
              <div className="Screen-Bar" style={{"backgroundColor": Colors.yellow}}></div>
              <div className="Screen-Bar" style={{"backgroundColor": Colors.green}}></div>
              <div className="Screen-Bar" style={{"backgroundColor": Colors.blue}}></div>
              <div className="Screen-Bar" style={{"backgroundColor": Colors.turquoise}}></div>
              <div className="Screen-Bar" style={{"backgroundColor": Colors.lavender}}></div>
              <div className="Screen-Bar" style={{"backgroundColor": Colors.purple}}></div>
              <p className="Click-Me-Text">click me</p>
            </div>
            <img style={{width: COMPUTER_WIDTH, cursor: "pointer"}} src={computer} alt="computer"/>
          </div>
          <div className="Computer-Shadow" style={{width: COMPUTER_WIDTH - 40}}></div>
        </div>
      </div>
    )
  }
}

export default Landing;
